export { default as GoogleMap } from './GoogleMap';